import { render, staticRenderFns } from "./actDetailList.vue?vue&type=template&id=22593e7c&scoped=true"
import script from "./actDetailList.vue?vue&type=script&lang=js"
export * from "./actDetailList.vue?vue&type=script&lang=js"
import style0 from "./actDetailList.vue?vue&type=style&index=0&id=22593e7c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22593e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22593e7c')) {
      api.createRecord('22593e7c', component.options)
    } else {
      api.reload('22593e7c', component.options)
    }
    module.hot.accept("./actDetailList.vue?vue&type=template&id=22593e7c&scoped=true", function () {
      api.rerender('22593e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_reconsideration/components/actDetailList.vue"
export default component.exports